import CSSRulePlugin from 'gsap/CSSRulePlugin'
import gsap from 'gsap'
import { boot } from 'quasar/wrappers'

export default boot(({ app }) => {
  gsap.registerPlugin(CSSRulePlugin)
})
